var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.637,
    height: 21.91,
    viewBox: "0 0 23.637 21.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61160",
    "data-name": "Group 61160",
    transform: "translate(-15302.133 -4856.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "field",
    transform: "translate(15302.133 4837.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60924",
    "data-name": "Group 60924",
    transform: "translate(0 22.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60923",
    "data-name": "Group 60923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87748",
    "data-name": "Path 87748",
    d: "M17.05,97.284v-.719a2.748,2.748,0,0,0,1.625-2.637c0-2.505-2.584-3.71-4.011-1.891-1.15,1.466-.646,3.918,1,4.528v.7A61.891,61.891,0,0,0,0,98.855v6.486a37.7,37.7,0,0,1,19.8-7.967C18.992,97.337,18.065,97.3,17.05,97.284Z",
    transform: "translate(0 -91.161)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60926",
    "data-name": "Group 60926",
    transform: "translate(0 29.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60925",
    "data-name": "Group 60925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87749",
    "data-name": "Path 87749",
    d: "M0,264.034v2.55H6.215a22.529,22.529,0,0,1,5.776-6.805,25.378,25.378,0,0,1,7.917-4.154h0l.042-.014C12.695,256.465,5.378,259.154,0,264.034Z",
    transform: "translate(0 -255.611)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60928",
    "data-name": "Group 60928",
    transform: "translate(7.82 30.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60927",
    "data-name": "Group 60927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87750",
    "data-name": "Path 87750",
    d: "M169.38,280.653h8.729a23.169,23.169,0,0,1,6.2-10.292A22.739,22.739,0,0,0,169.38,280.653Z",
    transform: "translate(-169.38 -270.361)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60930",
    "data-name": "Group 60930",
    transform: "translate(17.981 31.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60929",
    "data-name": "Group 60929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87751",
    "data-name": "Path 87751",
    d: "M389.5,302.743h5.655v-9.222A22.233,22.233,0,0,0,389.5,302.743Z",
    transform: "translate(-389.5 -293.521)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60932",
    "data-name": "Group 60932",
    transform: "translate(18.764 22.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60931",
    "data-name": "Group 60931",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87752",
    "data-name": "Path 87752",
    d: "M408.767,91.231a2.558,2.558,0,0,0-2.317,2.763,2.748,2.748,0,0,0,1.625,2.637v.747q.688-.069,1.385-.118v-.629a2.3,2.3,0,0,0,1-.746C411.812,94.164,410.84,91.231,408.767,91.231Z",
    transform: "translate(-406.45 -91.231)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60934",
    "data-name": "Group 60934",
    transform: "translate(0 18.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60933",
    "data-name": "Group 60933",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4795",
    "data-name": "Ellipse 4795",
    cx: 2.02,
    cy: 2.02,
    r: 2.02,
    fill: "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.772e8a1ed2858ef1bbea3af425be15c8.svg";
export { ForwardRef as ReactComponent };